/* @flow */

import { useSelector, shallowEqual } from 'react-redux';

import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';

import type { Membership } from '@e180/domain/lib/membership/type';

export default function useMembership(): ?Membership {
  // Membership schema doesn't depend on any other data for now, but the
  // `getMembership` selector returns a new membership object whenever a part of
  // the `entities` state slice changes. Therefore it returns a new membership
  // object whenever the entities are modified, even if the membership data
  // hasn't changed. To mitigate that, we use a shallow comparison instead of
  // the default strict comparison of react-redux.
  return useSelector(getMembership, shallowEqual);
}
